export default "__VITE_ASSET__CoqEx0SQ__"